import { MONTH_ARRAY, DYNAMIC_ALBUMS } from '../../constants'
import { pluralize } from '../../utils/string'
import { getHash } from '../../utils/images'
import { emptyStructure } from '../../redux/query'

const DATE_DAYS_ARRAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export function getAlbumStructure (item, entities) {
  let album
  if (isDynamicAlbum(item)) {
    album = generateDynamicAlbum(item)
  } else if (entities.albums[item.album]) {
    album = JSON.parse(entities.albums[item.album].json_data)
  }
  if (item.albumSort) {
    const [value, operator] = item.albumSort.split('-')
    album.sort.value = value
    album.sort.operator = operator || null
  }
  return album
}

export function ensureImages (structure, search, searchImages) {
  const images = search[getHash(structure)]
  if (!images || (!images.data && !images.fetching)) {
    return searchImages(structure)
  }
  return Promise.resolve()
}

export function canPlay (id, thing, alreadyPlayed, externals) {
  console.log('Checking if I can play ', thing, externals)
  if (thing.scheduleHour) {
    console.log('NO: Scheduled for hour of day ' + thing.scheduleHour)
    return false
  }
  if (alreadyPlayed.indexOf(id) !== -1) {
    console.log('NO: Already played')
    return false
  }
  if (isLimited(thing, externals)) {
    return false
  }
  return true
}

function isLimited (thing, externals) {
  const date = new Date()
  if (thing.limitHours && thing.limitHours.indexOf(date.getHours()) === -1) {
    console.log('NO: Hour of day does not match')
    return true
  }
  if (thing.limitDate && thing.limitDate.indexOf(date.getDate()) === -1) {
    console.log('NO: Day of month does not match')
    return true
  }
  const day = DATE_DAYS_ARRAY[date.getDay()]
  if (thing.limitDay && thing.limitDay.indexOf(day) === -1) {
    console.log('NO: Day of week does not match')
    return true
  }
  const month = MONTH_ARRAY[date.getMonth()]
  if (thing.limitMonth && thing.limitMonth.indexOf(month) === -1) {
    console.log('NO: Month does not match')
    return true
  }
  if (externals.weather && thing.limitWeather && thing.limitWeather.indexOf(externals.weather) === -1) {
    console.log('NO: Weather does not match')
    return true
  }
  return false
}

// Returns true if a scheduled thing is found
// Returns false if not
export function checkSchedule (things, externals, onSuccess) {
  const date = new Date()
  const minutes = date.getMinutes()
  const hour = date.getHours()
  console.log('Checking schedule', hour, minutes)
  if (minutes === 0) {
    for (let i = 0; i !== things.length; i++) {
      const thing = things[i]
      if (
        thing.scheduleHour &&
        thing.scheduleHour.indexOf(hour) !== -1 &&
        isLimited(thing, externals) === false
      ) {
        onSuccess(thing)
        return true
      }
    }
  }
  return false
}

export function generateDynamicAlbum (item) {
  if (item.album === 'images') {
    return {
      ...emptyStructure,
      queries: [],
      include: item.images
    }
  }
}

export function getItemName (item, entities) {
  if (!item) return ''
  if (item.name) {
    return item.name
  }
  // Playlist structure
  if (item.albums) {
    if (item.albums.length === 1) {
      return getItemName(item.albums[0], entities)
    }
    return pluralize(item.albums.length, 'album')
  }
  // Album in playlist
  if (item.album) {
    if (entities.albums[item.album]) {
      return entities.albums[item.album].name
    }
    if (item.album === 'images') {
      return pluralize(item.images.length, 'image')
    }
    if (DYNAMIC_ALBUMS[item.album]) {
      return DYNAMIC_ALBUMS[item.album]
    }
  }
  return ''
}

const DYNAMIC_ALBUM_KEYS = Object.keys(DYNAMIC_ALBUMS)

export function isDynamicAlbum (item) {
  return DYNAMIC_ALBUM_KEYS.indexOf(item.album) !== -1
}



// WEBPACK FOOTER //
// ./src/components/playlist/utils.js